import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, InputSignal, ViewEncapsulation } from '@angular/core';
import { SellerSettings } from '@api/src/models/AgentApi/Contract/seller-settings';
import { CommissionSource } from '@core/calculator/commission-source';
import { Product } from '@core/calculator/product';
import { TranslatePipe } from '@ngx-translate/core';
import { CurrencyValue } from '@shared/components/currency-value/currency-value';
import { TotalPriceCalculatePipe } from '@shared/pipes/total-price-calculate/total-price-calculate-pipe';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-price-block',
    imports: [TranslatePipe, CurrencyValue, TotalPriceCalculatePipe, AsyncPipe],
    templateUrl: './price-block.html',
    styleUrl: './price-block.scss',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'agent-price-block',
    },
})
export class PriceBlock {
    public readonly sellerSettings: InputSignal<SellerSettings> = input();
    public readonly price: InputSignal<number> = input();
    public readonly product: InputSignal<Product> = input();
    public readonly sellWithRegistrationFlag: InputSignal<boolean> = input();

    public readonly productEnum: typeof Product = Product;
    public readonly commissionSource: typeof CommissionSource = CommissionSource;
}
